import Menu from './components/menu';
import InView from './components/in-view';
import { infoSlider } from './components/info-slider.js';
import { infoSlide } from './components/info-slide.js';
import { storiesSlider } from './components/stories-slider.js';
import { accordion } from './components/accordion';
import { level } from './components/level.js';
import { questionFormPopup } from './components/question-form.js';
import { exit } from './components/exit.js';
import { info } from './components/info.js';
import { openQuestion } from './components/open-question.js';
import { accordionQuiz } from './components/accordion-quiz.js';
import { shareModal } from './components/share.js';

const menuElement = document.querySelector( '[data-menu]' );
const quiz = document.querySelector( '[data-quiz]' );
const inView = new InView( '[data-in-view]' );
const Accordions = document.querySelectorAll( '[data-accordion]' );
const infoSliderElements = document.querySelectorAll('[data-info-slider]');
const infoSlides = document.querySelectorAll('[data-info-slide]');
const storiesSliderElements = document.querySelectorAll('[data-stories-slider]');
const accordionQuizLevel = document.querySelectorAll('[data-accordion-quiz]');
const levelElement = document.querySelectorAll('[data-level]');
const formElement = document.querySelectorAll('[data-question-form]');
const exitPopup = document.querySelectorAll('[data-exit]');
const infoPopup = document.querySelectorAll('[data-info]');
const openQuestionElements = document.querySelectorAll('[data-question-open]');
const shareElement = document.querySelector('[data-share-modal]');
if (shareElement) {
    shareModal();
}

if (menuElement && !quiz) {
    const menu = new Menu(menuElement);
}

if (levelElement.length > 0) {
    level();
    console.log('level');
}

if (Accordions.length > 0) {
    Accordions.forEach(element => {
        accordion.init(element);
    });
}

if (formElement.length > 0) {
    questionFormPopup();
    console.log('question popup');
}

if (exitPopup.length > 0) {
    console.log('exit');
    exit();
}

if (infoPopup.length > 0) {
    console.log('info');
    info();
}

if (infoSliderElements.length > 0) {
    infoSliderElements.forEach(element => {
        infoSlider(element);
    });
}

if (infoSlides.length > 0) {
    infoSlides.forEach(element => {
        infoSlide(element);
    });
}

if (storiesSliderElements.length > 0) {
    storiesSliderElements.forEach(element => {
        storiesSlider(element);
    });
}

if (accordionQuizLevel.length > 0) {
    console.log('quiz level accordion');
    accordionQuiz();
}

if (openQuestionElements.length > 0) {
    console.log('open question');
    openQuestion();
}